























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { ActionMethod } from "vuex";
import FileSaver from "file-saver";
import axios from "axios";
import SignalRHub from "@/services/SignalRHub";
import { AZNCONNECT_API } from "@/services/aznconnect-api";
import {
  ReferralEspoedDetailsModel,
  RelatedReferralModel,
  Attachment,
  Sign,
  SignValue,
  ObservationHeader,
  CordysAnalysisResult,
  CordysMessage,
  ExternalMonitorLinkModel,
  TrianectReportModel,
} from "@/types/aznconnect_api";
import DetailPaneRelatedReferrals from "@/components/DetailPaneRelatedReferrals.vue";
import MessageHistoryDialog from "@/components/espoedv2/MessageHistoryDialog.vue";
import RawMessageView from "@/components/RawMessageView.vue";
import ReferralIcon from "@/components/ReferralIcon.vue";
import Timings from "@/components/espoed/Timings.vue";
import InformationCard from "@/components/InformationCard.vue";
import InformationCardValues from "@/components/InformationCardValues.vue";
import DefaultPatientSearchDialog from "@/components/espoed/DefaultPatientSearchDialog.vue";
import TrendLineChart from "@/components/TrendLineChart.vue";
import { LabeledText, SignalREvents } from "@/types/types";
import AmbulanceFeedbackDetailPane from "@/components/ambulancefeedback/DetailPane.vue";
import ProfessionalSummaryDetailPane from "@/components/professionalsummary/DetailPane.vue";
import GeneralCommentView from "@/components/espoedv2/GeneralCommentView.vue";
import BodyPositionView from "@/components/espoedv2/BodyPositionView.vue";
import PrimarySurveyV2View from "@/components/espoedv2/PrimarySurveyV2View.vue";
import SecundarySurveyV2View from "@/components/espoedv2/SecundarySurveyV2View.vue";
import MedicalConditionWorkingDiagnosisSectionView from "@/components/espoedv2/MedicalConditionWorkingDiagnosisSectionView.vue";
import ConsentSectionView from "@/components/espoedv2/ConsentSectionView.vue";
import AgreementsWithPatientView from "@/components/espoedv2/AgreementsWithPatientView.vue";
import ConsultingExternalProfessionalSectionView from "@/components/espoedv2/ConsultingExternalProfessionalSectionView.vue";
import { UserPermissions } from "@/types/store";
import { decodeVehicleNumber } from "@/services/vehicleNumberDecoder";
import TeamsCallAmbulance from "@/components/msGraph/TeamsCallAmbulance.vue";
import ArrivalTimerView from "@/components/espoedv2/ArrivalTimerView.vue";
import { PersonFormatter } from "@/services/personFormatter";
import { Configuration } from "@/services/Configuration";

@Component({
  name: "espoedv2-detail-pane",
  components: {
    "detail-pane-related-referrals": DetailPaneRelatedReferrals,
    "information-card": InformationCard,
    "information-card-values": InformationCardValues,
    "referral-icon": ReferralIcon,
    timings: Timings,
    "default-patient-search-dialog": DefaultPatientSearchDialog,
    "trendline-chart": TrendLineChart,
    "raw-message-view": RawMessageView,
    "ambulance-feedback-detail-pane": AmbulanceFeedbackDetailPane,
    "professional-summary-detail-pane": ProfessionalSummaryDetailPane,
    "general-comment-view": GeneralCommentView,
    "body-position-view": BodyPositionView,
    "primary-survey-v2-view": PrimarySurveyV2View,
    "secundary-survey-v2-view": SecundarySurveyV2View,
    "medical-condition-working-diagnosis-section-view": MedicalConditionWorkingDiagnosisSectionView,
    "consent-section-view": ConsentSectionView,
    "agreements-with-patient-view": AgreementsWithPatientView,
    "consulting-external-professional-section-view": ConsultingExternalProfessionalSectionView,
    "teams-call-ambulance": TeamsCallAmbulance,
    "arrival-timer-view": ArrivalTimerView,
    "message-history-dialog": MessageHistoryDialog,
  },
})
export default class DetailPane extends Vue {
  get configuration() {
    return Configuration;
  }
  @Prop({ default: null })
  referral!: ReferralEspoedDetailsModel;

  @Prop({ default: null })
  relatedReferrals!: RelatedReferralModel[];

  @Prop({ default: null })
  referralState!: string;

  @Prop({ default: false })
  isReadOnly!: boolean;

  @Prop({ default: false })
  allowLinkPatientNumber!: boolean;

  @Prop({ default: false })
  allowSetReferralState!: boolean;

  @Prop({ default: true })
  allowPageClose!: boolean;

  @Prop({ default: "" })
  patientNumber!: string;

  @Prop({ default: null })
  signalRHub!: SignalRHub;

  @Prop({ default: false })
  allowProfessionalSummary!: boolean;

  @Prop({ default: false })
  isHistoryView!: boolean;

  MODE_ESPOED: number = 1;
  MODE_AMBU_FEEDBACK: number = 2;
  MODE_PS: number = 3;
  MODE_EXTERNAL_MONITOR = 4;

  mode: number = this.MODE_ESPOED;

  @Getter("userPermissions")
  userPermissions!: UserPermissions;

  @Action("resolveReferral", { namespace: "espoed" })
  resolveReferralAction!: ActionMethod;

  @Watch("referral", { immediate: true }) onPropChanged(
    value: ReferralEspoedDetailsModel,
    oldValue: ReferralEspoedDetailsModel,
  ) {
    this.signTimestamps = this.sortSignTimestamps();
    this.resetCordysState();
  }

  resolveReferral(): void {
    this.resolveReferralAction(this.referral.Reference);
  }

  isEditingPatientNumber: boolean = false;
  showImageDialog: boolean = false;
  showHistoryDialog: boolean = false;
  signTimestamps: Array<string> = [];
  attachmentPreviewText: string | null = null;
  attachmentPreviewUrl: string = "";

  developerMode: boolean = false;
  advancedMode: boolean = false;
  failedToLoad: boolean = false;

  showSignChart: boolean = false;
  signChartData: any = {};
  signChartOptions: any = {};

  externalMonitorModel: ExternalMonitorLinkModel | null = null;

  // --- Trianect: prehospitaal EEG-rapport ---
  // Er wordt niets bewaard: het rapport leeft alleen zolang deze component bestaat.
  trianectReport: TrianectReportModel | null = null;
  trianectLoading: boolean = false;
  trianectError: string = "";
  trianectDemoMode: boolean = Configuration.trianectEegDemoMode;

  get monitorStatusText(): string {
    const model = this.externalMonitorModel;
    if (model == null) return "-";
    if (model.IsOnline === true) return "Online";
    if (model.IsOnline === false) return "Offline";
    return model.DeviceStatus ? model.DeviceStatus : "Onbekend";
  }

  get monitorStatusClass(): string {
    const model = this.externalMonitorModel;
    if (model == null || model.IsOnline == null)
      return "monitor-status-unknown";
    return model.IsOnline ? "monitor-status-online" : "monitor-status-offline";
  }

  get showMonitorWidget(): boolean {
    const model = this.externalMonitorModel;
    return model != null && !!model.WidgetUrl && model.IsOnline !== false;
  }

  // --- Cordys ECG AI-analyse ---
  // DEMO MODE: simuleert de Cordys-flow (insturen, rapport) zonder backend,
  // zodat de UI gedemonstreerd kan worden.
  cordysDemoMode: boolean = Configuration.cordysEcgDemoMode;

  // Analyseresultaat per bijlage (key = SetId) van analyses die in deze sessie
  // gedraaid of opgehaald zijn. Eerder bewaarde analyses komen mee met de bijlage
  // zelf (attachment.EcgAnalysis), zonder PDF.
  cordysResults: { [setId: string]: CordysAnalysisResult } = {};
  // SetId van de bijlage die op dit moment geanalyseerd wordt (null = geen)
  cordysRunningSetId: string | null = null;
  // SetId van de bijlage waarvan het bewaarde rapport opgehaald wordt (null = geen)
  cordysFetchingSetId: string | null = null;
  cordysError: string = "";

  created(): void {
    if (this.signalRHub != null) {
      this.signalRHub.hubProxy.on(
        SignalREvents.UpdateEtaTime,
        this.etaTimeUpdatedHandler,
      );
    }
  }

  beforeDestroy(): void {
    if (this.signalRHub != null) {
      this.signalRHub.hubProxy.off(
        SignalREvents.UpdateEtaTime,
        this.etaTimeUpdatedHandler,
      );
    }
  }

  mounted() {
    var me = this;
    if (me.referral.HasExternalMonitorApi && !me.isHistoryView) {
      AZNCONNECT_API.get(
        "/ExternalMonitor/Get?referenceId=" + me.referral.Reference,
        {},
      ).then(response => {
        me.externalMonitorModel = response.data as ExternalMonitorLinkModel;
      });
    }
  }

  get patientInformationValues(): Array<LabeledText> {
    const formatDate = Vue.filter("formatDate");
    const values: Array<LabeledText> = [];
    const referralModel = this.referral as ReferralEspoedDetailsModel;

    let birthDate = "";
    if (referralModel.PatientBirthDate) {
      birthDate = formatDate(referralModel.PatientBirthDate);
      if (referralModel.PatientAge != null) {
        birthDate = birthDate + " (" + referralModel.PatientAge + " jaar)";
      }
    }
    values.push(new LabeledText("Geboortedatum", birthDate));
    values.push(new LabeledText("BSN", referralModel.PatientBSN));

    if (referralModel.PassportNumber !== null) {
      values.push(
        new LabeledText("Paspoortnummer", referralModel.PassportNumber),
      );
    }
    if (referralModel.DriversLicenseNumber !== null) {
      values.push(
        new LabeledText("Rijbewijsnummer", referralModel.DriversLicenseNumber),
      );
    }

    if (referralModel.IDCardNumber !== null) {
      values.push(
        new LabeledText("Identiteitskaartnummer", referralModel.IDCardNumber),
      );
    }

    if (referralModel.AliensDocumentNumber !== null) {
      values.push(
        new LabeledText(
          "Vreemdelingen-documentnummer",
          referralModel.AliensDocumentNumber,
        ),
      );
    }

    values.push(
      new LabeledText(
        "Adres",
        `${referralModel.PatientAddressLine1}, ${
          referralModel.PatientAddressLine2
        }`,
      ),
    );

    values.push(new LabeledText("Telefoon", referralModel.PatientPhoneNumber));
    values.push(new LabeledText("E-mail", referralModel.PatientMailAddress));
    values.push(
      new LabeledText(
        "Verzekerd?",
        referralModel.InsuranceValid == true ? "Ja" : "Nee",
      ),
    );

    const practitioner = PersonFormatter.formatPractitioner(
      referralModel.GeneralPractitionerName,
      referralModel.GeneralPractitionerAgbCode,
    );
    values.push(new LabeledText("Huisarts", practitioner));
    values.push(
      new LabeledText(
        "Praktijk ",
        referralModel.ScopingOrganizationName || "Onbekend",
      ),
    );

    values.push(
      new LabeledText(
        "Praktijk adres",
        referralModel.ScopingOrganizationAddress || "Onbekend",
      ),
    );

    values.push(
      new LabeledText(
        "Praktijk telefoon",
        referralModel.ScopingOrganizationTel || "Onbekend",
      ),
    );

    values.push(
      new LabeledText("Contactpersoon", referralModel.ContactName || "-"),
    );

    values.push(
      new LabeledText(
        "Relatie",
        referralModel.ContactRoleTypeDisplayName || "-",
      ),
    );

    values.push(
      new LabeledText(
        "Contactpersoon tel.",
        referralModel.ContactPhoneNumber || "-",
      ),
    );

    return values;
  }

  get rideInformationValues(): Array<LabeledText> {
    const formatDate = Vue.filter("formatDate");
    const formatDateTime = Vue.filter("formatDateTime");
    const values: Array<LabeledText> = [];
    const referralModel = this.referral as ReferralEspoedDetailsModel;

    if (referralModel.DepartureTime) {
      values.push(
        new LabeledText(
          "Datum",
          formatDate(referralModel.DepartureTime.DateTime),
        ),
      );
    }

    const departureLocation = [
      referralModel.DepartureLocation,
      referralModel.DeparturePostalCode,
    ]
      .filter(Boolean)
      .join(", ");

    values.push(new LabeledText("Vertrek locatie", departureLocation));
    values.push(
      new LabeledText("Organisatie", referralModel.SendingEntity || ""),
    );
    values.push(new LabeledText("Ritnummer", referralModel.Reference || ""));

    const ambulanceId = referralModel.AmbulanceId || "";
    let label = "Ambulance";

    if (ambulanceId) {
      const { vehicle, specialCase } = decodeVehicleNumber(ambulanceId);
      if (vehicle === "MMT" && specialCase === "Helikopter") {
        label = "Helicopter";
      }
    }

    values.push(new LabeledText(label, ambulanceId));

    values.push(
      new LabeledText("Wzd/Wvggz", referralModel.WzdWvggzMeasure || ""),
    );
    values.push(
      new LabeledText(
        "Aanvang TVZ",
        formatDateTime(referralModel.StartTimeInvoluntaryCare) || "",
      ),
    );

    values.push(
      new LabeledText(
        "Zorgaanvrager",
        referralModel.CareRequesterType || "Onbekend",
      ),
    );

    return values;
  }

  get anamneseValues(): Array<LabeledText> {
    const values: Array<LabeledText> = [];
    const referralModel = this.referral as ReferralEspoedDetailsModel;

    if (referralModel && referralModel.SecondarySurveys) {
      for (const secondarySurvey of referralModel.SecondarySurveys) {
        values.push(
          new LabeledText(secondarySurvey.Name, secondarySurvey.Value),
        );
      }
    }

    return values;
  }

  get mechanismValues(): Array<LabeledText> {
    const values: Array<LabeledText> = [];
    const referralModel = this.referral as ReferralEspoedDetailsModel;

    if (
      referralModel &&
      referralModel.MechanismObservations &&
      referralModel.MechanismObservations.length > 0
    ) {
      for (const mechanismObservation of referralModel.MechanismObservations) {
        values.push(
          new LabeledText(
            mechanismObservation.Code,
            mechanismObservation.Value,
          ),
        );
      }
    } else if (
      referralModel &&
      referralModel.Mechanisms &&
      referralModel.Mechanisms.length == 0
    ) {
      values.push(new LabeledText("Geen", ""));
    }
    return values;
  }

  get faAmbulanceIdIcon(): string {
    const referralModel = this.referral as ReferralEspoedDetailsModel;

    const ambulanceId = referralModel.AmbulanceId;
    if (!ambulanceId) return "";

    const { vehicle, specialCase } = decodeVehicleNumber(ambulanceId);
    const isHelicopter = vehicle === "MMT" && specialCase === "Helikopter";

    return isHelicopter ? "fa fa-helicopter" : "fa fa-ambulance";
  }

  injuryValues(injuryObservationHeader: ObservationHeader): Array<LabeledText> {
    const values: Array<LabeledText> = [];
    const referralModel = this.referral as ReferralEspoedDetailsModel;
    if (injuryObservationHeader.ObservationModels != null) {
      for (const injuryObservation of injuryObservationHeader.ObservationModels) {
        values.push(
          new LabeledText(
            `${injuryObservation.Code}`,
            `${injuryObservation.Value}`,
          ),
        );
      }
    }

    return values;
  }

  sortSignTimestamps(): Array<string> {
    let signTimestamps = [];
    if (this.referral && this.referral.Signs) {
      for (const sign of this.referral.Signs) {
        for (const signValue of sign.Values) {
          if (signTimestamps.find(t => t == signValue.Timestring) == null) {
            signTimestamps.push(signValue.Timestring);
          }
        }
      }
    }
    return signTimestamps.sort();
  }

  get filters(): any {
    return this.$options.filters || {};
  }

  signOnClickHandler(sign: Sign): void {
    let vm = this;
    var signChartDataValues: Array<number> = [];
    var calculatedMaxY: number = 0;

    var ascendingTimestamps = this.signTimestamps.sort();

    ascendingTimestamps.forEach(signTimestamp => {
      var stringValue = vm.getSignValue(sign, signTimestamp);
      var numberValue = Number.parseInt(stringValue);

      if (numberValue && numberValue > calculatedMaxY) {
        calculatedMaxY = numberValue * 1.2;
      }

      signChartDataValues.push(numberValue);
    });

    var timestamps = ascendingTimestamps.map(x => this.filters.formatTime(x));

    this.signChartData = {
      labels: timestamps,
      datasets: [
        {
          label: sign.Name,
          fill: false,
          lineTension: 0.2,
          backgroundColor: "#181E3C",
          borderColor: "#181E3C",
          data: signChartDataValues,
        },
      ],
    };

    this.signChartOptions = {
      legend: {
        display: true,
        position: "top",
        labels: {
          fontFamily: "Roboto, sans-serif",
          boxWidth: 16,
        },
      },
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              suggestedMin: 0,
              suggestedMax: calculatedMaxY,
            },
          },
        ],
      },
      title: {
        display: false,
        text: sign.Name,
      },
    };

    this.showSignChart = true;
  }

  copyLinkToClipboard(): void {
    const route = this.$router.resolve({
      name: "referral-details",
      params: { referralId: this.referral.Reference || "" },
    });
    const url = window.location.origin + "/" + route.href;

    var temp = $("<input>");
    $("body").append(temp);
    temp.val(url).select();
    try {
      var successful = document.execCommand("copy");
      var msg = successful ? "successful" : "unsuccessful";
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
    temp.remove();
  }

  toggleDeveloperMode(): void {
    var me = this;
    me.developerMode = !me.developerMode;
  }

  downloadReferral(): void {
    var me = this;

    let model = {
      Action: "DownloadReferralPdf",
      Parameters: { id: me.referral.Reference },
      FileType: "pdf",
    };

    var url = "/FileDownload/RequestDownload";
    AZNCONNECT_API.post(url, model)
      .then(response => {
        window.location.href = response.data;
      })
      .catch(error => {
        console.error(
          "Failed to request the download short live token url",
          error,
        );
      });
  }

  toggleAdvancedMode(): void {
    var me = this;
    me.advancedMode = !me.advancedMode;
  }

  getSignValue(sign: Sign, timestamp: string): string {
    const signValue: SignValue | undefined = sign.Values.find(
      value => value.Timestring == timestamp,
    );
    return signValue ? signValue.Value : "";
  }

  getSignUnit(sign: Sign) {
    var displayValue = "";
    if (sign != null) {
      displayValue += sign.Value;
      if (sign.Unit) {
        displayValue += " " + sign.Unit;
      }
      if (sign.DenominatorUnit) {
        displayValue += " / ";
        if (sign.DenominatorValue && sign.DenominatorValue !== "1") {
          displayValue += sign.DenominatorValue;
        }
        displayValue += sign.DenominatorUnit;
      }
    }
    return displayValue;
  }

  previewAttachment(attachment: Attachment): void {
    var url = "/FileDownload/RequestDownload";
    AZNCONNECT_API.post(url, attachment.Open)
      .then(response => {
        // Create temporary link to preserve filename
        this.attachmentPreviewText = attachment.Text;
        this.attachmentPreviewUrl = response.data;
      })
      .catch(error => {
        console.error(
          "Failed to request the download short live token url",
          error,
        );
      });
  }

  closeAttachmentPreview(): void {
    // Revoke URL to free memory
    this.attachmentPreviewText = null;
    this.attachmentPreviewUrl = "";
  }

  isImage(attachment: Attachment): boolean {
    // Extract extension from filename
    const filename = attachment.Text || "";
    const lastDotIndex = filename.lastIndexOf(".");
    let extension = "";

    if (lastDotIndex > 0 && lastDotIndex < filename.length - 1) {
      extension = filename.substring(lastDotIndex + 1).toLowerCase();
    } else if (attachment.Open.FileType) {
      extension = attachment.Open.FileType.toLowerCase();
    }

    return (
      extension === "jpg" ||
      extension === "jpeg" ||
      extension === "png" ||
      extension === "gif" ||
      extension === "bmp" ||
      extension === "webp"
    );
  }

  getMimeTypeFromExtension(fileType: string | null): string {
    if (!fileType) return "application/octet-stream";

    const ext = fileType.toLowerCase();
    const mimeTypes: { [key: string]: string } = {
      // Images
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      gif: "image/gif",
      bmp: "image/bmp",
      webp: "image/webp",
      svg: "image/svg+xml",
      // Documents
      pdf: "application/pdf",
      doc: "application/msword",
      docx:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ppt: "application/vnd.ms-powerpoint",
      pptx:
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      txt: "text/plain",
      csv: "text/csv",
      xml: "application/xml",
      json: "application/json",
      // Archives
      zip: "application/zip",
      rar: "application/x-rar-compressed",
      "7z": "application/x-7z-compressed",
    };

    return mimeTypes[ext] || "application/octet-stream";
  }

  openAttachment(attachment: Attachment): void {
    var url = "/FileDownload/RequestDownload";
    AZNCONNECT_API.post(url, attachment.Open)
      .then(response => {
        // Create temporary link to preserve filename
        const link = document.createElement("a");
        link.href = response.data;
        link.target = "_blank";
        link.download = attachment.Text;

        //For PDFs and images, remove download attribute to view in browser
        if (
          attachment.Open.FileType === "pdf" ||
          attachment.Open.FileType === "image"
        ) {
          link.removeAttribute("download");
        }

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(error => {
        console.error(
          "Failed to request the download short live token url",
          error,
        );
      });
  }

  downloadAttachment(attachment: Attachment): void {
    var url = "/FileDownload/RequestDownload";
    AZNCONNECT_API.post(url, attachment.Download)
      .then(response => {
        window.location.href = response.data;
      })
      .catch(error => {
        console.error(
          "Failed to request the download short live token url",
          error,
        );
      });
  }

  // --- Cordys ECG AI-analyse ---
  get showCordysSection(): boolean {
    const available =
      this.cordysDemoMode || this.referral.HasCordysApi === true;
    return available && this.ecgAttachments.length > 0;
  }

  get ecgAttachments(): Attachment[] {
    const attachments = (this.referral.Attachments || []).filter(attachment =>
      this.isEcgAttachment(attachment),
    );
    if (attachments.length === 0 && this.cordysDemoMode) {
      return [
        {
          Id: -1,
          SetId: "demo-ecg",
          VersionNumber: "1",
          DateTime: new Date(),
          DisplayName: "12-afleidingen ECG (demo)",
          Text: "ECG_12_afleidingen.dcm",
          Download: { Action: "", Parameters: {}, FileType: "dcm" },
          Open: { Action: "", Parameters: {}, FileType: "dcm" },
          Code: "001",
        } as Attachment,
      ];
    }
    return attachments;
  }

  isEcgAttachment(attachment: Attachment): boolean {
    // ECG-bijlagen: code-waarde 001 in het externalDocument code-element
    return attachment.Code === "001";
  }

  // Eerst wat in deze sessie opgehaald of geanalyseerd is (dat heeft het PDF), dan
  // wat er bij de verwijzing bewaard staat.
  getCordysResult(attachment: Attachment): CordysAnalysisResult | null {
    return (
      this.cordysResults[attachment.SetId] || attachment.EcgAnalysis || null
    );
  }

  hasCordysReport(attachment: Attachment): boolean {
    return this.getCordysResult(attachment) != null;
  }

  isCordysRowLoading(attachment: Attachment): boolean {
    return this.cordysRunningSetId === attachment.SetId;
  }

  // Het bewaarde rapport wordt opgehaald: de knoppen staan even op laden.
  isCordysReportLoading(attachment: Attachment): boolean {
    return this.cordysFetchingSetId === attachment.SetId;
  }

  // Er loopt er maar een tegelijk: de analyse is een synchrone call die de
  // Cordys-engine bezet houdt.
  get cordysBusy(): boolean {
    return this.cordysRunningSetId !== null;
  }

  cordysMessagesFor(attachment: Attachment): CordysMessage[] {
    const result = this.getCordysResult(attachment);
    return result ? result.Messages : [];
  }

  cordysStatusTextFor(attachment: Attachment): string {
    const result = this.getCordysResult(attachment);
    if (result) {
      const formatDateTime = Vue.filter("formatDateTime");
      return result.AnalysedOn
        ? `Analyse voltooid op ${formatDateTime(result.AnalysedOn)}`
        : "Analyse voltooid";
    }
    if (this.isCordysRowLoading(attachment)) {
      // De engine schaalt naar nul, dus een koude start kost 15-30 seconden
      // bovenop de analyse zelf.
      return "ECG wordt geanalyseerd, dit kan een minuut duren...";
    }
    return "";
  }

  submitEcgAnalysis(attachment: Attachment): void {
    if (this.hasCordysReport(attachment) || this.cordysBusy) {
      // Er is al een rapport voor deze bijlage, of er loopt nog een analyse
      return;
    }
    this.cordysError = "";
    this.cordysRunningSetId = attachment.SetId;
    this.scrollCordysStatusIntoView();

    if (this.cordysDemoMode) {
      // Wachttijd simuleren zodat de demo de echte flow benadert.
      const delay = new Promise<void>(resolve =>
        window.setTimeout(resolve, 2500),
      );
      Promise.all([this.loadCordysDemoPdfBase64(), delay])
        .then(([pdf]) => {
          this.cordysRunningSetId = null;
          this.$set(this.cordysResults, attachment.SetId, {
            CorrelationId: `demo-${attachment.SetId}`,
            Messages: [],
            Pdf: pdf,
          });
          this.scrollCordysStatusIntoView();
        })
        .catch(error => {
          console.error("Failed to load the Cordys demo report", error);
          this.cordysRunningSetId = null;
          this.cordysError = "Demo-rapport kon niet geladen worden.";
        });
      return;
    }

    AZNCONNECT_API.post("/Cordys/Analyse", {
      ReferralMessageId: attachment.ReferralMessageId,
      AttachmentId: attachment.SetId,
    })
      .then(response => {
        this.cordysRunningSetId = null;
        this.$set(
          this.cordysResults,
          attachment.SetId,
          response.data as CordysAnalysisResult,
        );
        this.scrollCordysStatusIntoView();
      })
      .catch(error => {
        console.error("Failed to analyse ECG at Cordys", error);
        this.cordysRunningSetId = null;
        this.cordysError =
          (error.response &&
            error.response.data &&
            error.response.data.Message) ||
          "AI analyse is mislukt.";
      });
  }

  scrollCordysStatusIntoView(): void {
    this.$nextTick(() => {
      const ref = this.$refs.cordysStatusArea;
      const el = ref instanceof Element ? ref : ref ? (ref as Vue).$el : null;
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });
  }

  resetCordysState(): void {
    this.cordysResults = {};
    this.cordysRunningSetId = null;
    this.cordysFetchingSetId = null;
    this.cordysError = "";
  }

  openCordysReport(attachment: Attachment): void {
    this.getCordysReportBlob(attachment).then(blob => {
      if (!blob) {
        return;
      }
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
    });
  }

  downloadCordysReport(attachment: Attachment): void {
    this.getCordysReportBlob(attachment).then(blob => {
      if (blob) {
        FileSaver.saveAs(blob, `ECG-analyse-${attachment.SetId}.pdf`);
      }
    });
  }

  // Het PDF zit alleen in het geheugen als de analyse in deze sessie gedraaid is.
  // Bij een bewaarde analyse komt alleen de samenvatting mee met de bijlage; het
  // rapport zelf wordt hier opgehaald, eenmalig per sessie.
  getCordysReportBlob(attachment: Attachment): Promise<Blob | null> {
    const result = this.getCordysResult(attachment);
    if (!result) {
      return Promise.resolve(null);
    }
    if (result.Pdf) {
      return Promise.resolve(this.toPdfBlob(result.Pdf));
    }

    this.cordysError = "";
    this.cordysFetchingSetId = attachment.SetId;
    return AZNCONNECT_API.get("/Cordys/Report", {
      params: {
        referralMessageId: attachment.ReferralMessageId,
        attachmentId: attachment.SetId,
      },
    })
      .then(response => {
        this.cordysFetchingSetId = null;
        const stored = response.data as CordysAnalysisResult;
        this.$set(this.cordysResults, attachment.SetId, stored);
        return stored.Pdf ? this.toPdfBlob(stored.Pdf) : null;
      })
      .catch(error => {
        console.error("Failed to load the stored Cordys report", error);
        this.cordysFetchingSetId = null;
        this.cordysError = "Het bewaarde rapport kon niet opgehaald worden.";
        return null;
      });
  }

  toPdfBlob(base64: string): Blob {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return new Blob([bytes], { type: "application/pdf" });
  }

  // Het demorapport is een echt Cordys-rapport (zie Docs/cordys/demo_report.pdf)
  // dat als statisch bestand met de frontend meegeleverd wordt.
  loadCordysDemoPdfBase64(): Promise<string> {
    return axios
      .get("cordys/demo_report.pdf", { responseType: "arraybuffer" })
      .then(response => {
        const bytes = new Uint8Array(response.data as ArrayBuffer);
        // In stukken omzetten: String.fromCharCode loopt vast op een te lange
        // argumentenlijst bij een rapport van honderden kilobytes.
        const chunkSize = 0x8000;
        let binary = "";
        for (let i = 0; i < bytes.length; i += chunkSize) {
          const chunk = bytes.subarray(i, i + chunkSize);
          binary += String.fromCharCode.apply(
            null,
            (chunk as unknown) as number[],
          );
        }
        return btoa(binary);
      });
  }

  // --- Trianect: prehospital EEG report ---
  //
  // Unlike Cordys there is nothing to hang rows off: one referral, one report. And Trianect
  // analyses nothing, it hands over a report that already exists — hence "retrieve" and not
  // "start".

  get showTrianectSection(): boolean {
    return (
      (this.trianectDemoMode || this.referral.HasTrianectApi === true) &&
      !this.isHistoryView
    );
  }

  // The ritnummer, derived the same way the backend does. The ReferenceId has the shape
  // {region}-{year}-{ritnummer}-{sequence}, e.g. 07-2026-37395-01, optionally followed by
  // _{locationAgb}-{departmentCode}. Purely for display here; the backend decides on it again
  // itself — see TrianectReportService.ExtractTransportId.
  get trianectTransportId(): string | null {
    const reference = this.referral.Reference;
    if (!reference) return null;

    const withoutSuffix = reference.split("_")[0];
    const parts = withoutSuffix.split("-");

    if (parts.length >= 3 && /^\d+$/.test(parts[2])) return parts[2];
    return /^\d+$/.test(withoutSuffix) ? withoutSuffix : null;
  }

  get hasTrianectReport(): boolean {
    return !!(this.trianectReport && this.trianectReport.PdfBase64);
  }

  get trianectStatusText(): string {
    if (this.trianectLoading) return "Rapport wordt opgehaald…";
    const report = this.trianectReport;
    if (!report) return "";
    if (report.Status === "Found") {
      const formatDateTime = Vue.filter("formatDateTime");
      return report.RetrievedOn
        ? `Opgehaald op ${formatDateTime(report.RetrievedOn)}`
        : "Rapport opgehaald";
    }
    // "No report" is everyday and therefore simply gets this line; anything pointing at a
    // malfunction goes to trianectError and comes back as a red alert.
    if (report.Status === "NotAvailable") {
      return report.Message || "Geen rapport beschikbaar voor deze rit.";
    }
    return "";
  }

  fetchTrianectReport(): void {
    if (this.trianectLoading) return;

    this.trianectError = "";
    this.trianectReport = null;
    this.trianectLoading = true;

    if (this.trianectDemoMode) {
      // Simulate the wait so the demo approximates the real flow.
      const delay = new Promise<void>(resolve =>
        window.setTimeout(resolve, 1500),
      );
      Promise.all([this.loadTrianectDemoPdfBase64(), delay])
        .then(([pdf]) => {
          this.trianectLoading = false;
          this.trianectReport = {
            TransportId: this.trianectTransportId,
            RetrievedOn: new Date().toISOString(),
            PdfBase64: pdf,
            Status: "Found",
            Message: null,
          };
        })
        .catch(error => {
          console.error("Failed to load the Trianect demo report", error);
          this.trianectLoading = false;
          this.trianectError = "Demo-rapport kon niet geladen worden.";
        });
      return;
    }

    AZNCONNECT_API.get("/Trianect/GetReport", {
      params: { referenceId: this.referral.Reference },
    })
      .then(response => {
        this.trianectLoading = false;
        const report = response.data as TrianectReportModel;
        this.trianectReport = report;
        // Found and NotAvailable are both normal outcomes; the rest is a malfunction and
        // belongs on screen as such.
        if (report.Status !== "Found" && report.Status !== "NotAvailable") {
          this.trianectError =
            report.Message || "Het EEG-rapport kon niet opgehaald worden.";
        }
      })
      .catch(error => {
        console.error("Failed to retrieve the Trianect report", error);
        this.trianectLoading = false;
        this.trianectError = "Het EEG-rapport kon niet opgehaald worden.";
      });
  }

  downloadTrianectReport(): void {
    const blob = this.trianectReportBlob();
    if (!blob) return;

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${this.trianectTransportId || "rit"}-trianect-eeg.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // Revoking straight away can abort the download in Safari before it has started.
    window.setTimeout(() => window.URL.revokeObjectURL(url), 10000);
  }

  openTrianectReport(): void {
    const blob = this.trianectReportBlob();
    if (!blob) return;

    const url = window.URL.createObjectURL(blob);
    window.open(url, "_blank");
    window.setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  }

  private trianectReportBlob(): Blob | null {
    const report = this.trianectReport;
    if (!report || !report.PdfBase64) return null;

    const binary = atob(report.PdfBase64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return new Blob([bytes], { type: "application/pdf" });
  }

  // The demo report is a real Trianect report (Docs/trianect/testrapporten/938422.pdf) shipped
  // with the frontend as a static file. It never touches the backend, so it can be shown even
  // when this machine's IP is not allow-listed by Trianect.
  loadTrianectDemoPdfBase64(): Promise<string> {
    return axios
      .get("trianect/demo_report.pdf", { responseType: "arraybuffer" })
      .then(response => {
        const bytes = new Uint8Array(response.data as ArrayBuffer);
        // Convert in chunks: String.fromCharCode chokes on an argument list that long for a
        // report of hundreds of kilobytes.
        const chunkSize = 0x8000;
        let binary = "";
        for (let i = 0; i < bytes.length; i += chunkSize) {
          const chunk = bytes.subarray(i, i + chunkSize);
          binary += String.fromCharCode.apply(
            null,
            (chunk as unknown) as number[],
          );
        }
        return btoa(binary);
      });
  }

  etaTimeUpdatedHandler(referenceId: string, etaDate: string, etaTime: string) {
    console.log(
      `Received ETA update for referenceId=${referenceId}: etaDate=${etaDate}, etaTime=${etaTime}`,
    );
    if (this.referral && this.referral.Reference === referenceId) {
      this.referral.EtaDate = etaDate;
      this.referral.EtaTime = etaTime;
    }
  }

  closeDetails(): void {
    this.$emit("close");
  }

  destroyed() {
    // Clean up preview URL
    this.attachmentPreviewText = null;
    this.attachmentPreviewUrl = "";
    this.$emit("closed");
  }
}
